import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect } from 'react';
import { setTokenProvider } from '../../utils/apis';

export const useAuth0Token = () => {
  const { getAccessTokenSilently, isLoading } = useAuth0();

  const getToken = useCallback(async () => {
    try {
      if (isLoading) {
        return null;
      }
      const token = await getAccessTokenSilently();
      return token;
    } catch (error) {
      return null;
    }
  }, [getAccessTokenSilently, isLoading]);

  useEffect(() => {
    if (!isLoading) {
      setTokenProvider(getToken);
    }
  }, [getToken, isLoading]);

  return { getToken, isLoading };
};
